module.exports = __webpack_public_path__ + "img/2_.10dabbbf.svg";